import { createContext, useMemo } from 'react';
import { IDelegationData } from '../DelegationLogic';

export interface IDelegationContext {
  delegationData?: IDelegationData;
}

export const DelegationContext = createContext<IDelegationContext | undefined>(
  undefined,
);

import * as React from 'react';

export interface IDelegationProviderProps {
  delegationData?: IDelegationData;
  children?: React.ReactNode;
}

/**
 * Context per avere a disposizione le informazioni sulla delega
 */
export function DelegationContextProvider(props: IDelegationProviderProps) {
  const { delegationData } = props;
  const value = useMemo(() => ({ delegationData }), [delegationData]);
  return (
    <DelegationContext.Provider value={value}>
      {props.children}
    </DelegationContext.Provider>
  );
}

/**
 * È nullo al di fuori della compilazione (es. richiesta inviata,
 * backoffice)
 */
export const useDelegationContext = () => {
  const context = React.useContext(DelegationContext);
  if (!context) {
    return null;
  }
  return context;
};
